const CHUNK_RELOAD_KEY = "vds:chunk-load-recovery";
const CHUNK_RELOAD_COOLDOWN_MS = 60_000;

export function isChunkLoadError(error) {
  const name = String(error?.name || "");
  const message = String(error?.message || error || "");

  return (
    name === "ChunkLoadError" ||
    /ChunkLoadError/i.test(message) ||
    /Loading (?:CSS )?chunk [^ ]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message) ||
    /Importing a module script failed/i.test(message)
  );
}

export function reloadForChunkLoadError(
  error,
  {
    storage = window.sessionStorage,
    location = window.location,
    now = Date.now(),
  } = {},
) {
  if (!isChunkLoadError(error) || typeof location?.reload !== "function") {
    return false;
  }

  const page = String(location.href || location.pathname || "");
  let previous = null;

  try {
    previous = JSON.parse(storage?.getItem(CHUNK_RELOAD_KEY) || "null");
  } catch {
    previous = null;
  }

  if (
    previous?.page === page &&
    Number.isFinite(previous?.at) &&
    now - previous.at < CHUNK_RELOAD_COOLDOWN_MS
  ) {
    return false;
  }

  try {
    storage?.setItem(CHUNK_RELOAD_KEY, JSON.stringify({ page, at: now }));
  } catch {
    // Recovery must still work when session storage is unavailable.
  }

  location.reload();
  return true;
}

export { CHUNK_RELOAD_COOLDOWN_MS, CHUNK_RELOAD_KEY };
